import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const penpot = defineConnector({
  identifier: "penpot",
  name: "Penpot",
  tagLine: "Open source design platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://design\\.penpot\\.app/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Enter your Penpot instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "design.penpot.app",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Use design.penpot.app for Penpot Cloud, or your self-hosted domain.",
        },
      ],
    },
    {
      title: "Create an access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Penpot, go to your **Profile › Access Tokens** and create a personal access token. See the [API docs](https://help.penpot.app/technical-guide/integration/) for details.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/rpc/command/get-profile`,
  },
});
